// extracted by css-extract-rspack-plugin
export default {"selectionWidth":"_7c4eebdf"};